import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Container from "@material-ui/core/Container";
import Toolbar from "@material-ui/core/Toolbar";
import useScrollTrigger from "@material-ui/core/useScrollTrigger";
import Slide from "@material-ui/core/Slide";

import ButtonScrollTo from "../Button/ButtonScrollTo";

import LogoImage from "../../img/logo.png";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    height: "auto",
  },
  logoContainer: {
    height: 50,
    width: 50,
  },
  logo: {
    height: "100%",
    width: "100%",
  },
  menu: {
    marginLeft: "auto",
    display: "flex",
    flexDirection: "row",
  }
}));

function HideOnScroll({ children }) {
  const trigger = useScrollTrigger({ threshold: 50 });

  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children}
    </Slide>
  );
}

function Navbar() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <HideOnScroll>
        <AppBar position="fixed" variant="outlined">
          <Container maxWidth="lg">
            <Toolbar>
              <div className={classes.logoContainer}>
                <img className={classes.logo} src={LogoImage} alt="Website Logo" width="50px" height="50px" />
              </div>
              <div className={classes.menu}>
                <ButtonScrollTo
                  variant="text"
                  color="inherit"
                  scrollid="features"
                  size="small"
                >
                  Features
                </ButtonScrollTo>
                <ButtonScrollTo
                  variant="outlined"
                  color="inherit"
                  scrollid="beli"
                  size="small"
                >
                  Beli
                </ButtonScrollTo>
              </div>
            </Toolbar>
          </Container>
        </AppBar>
      </HideOnScroll>
    </div>
  );
}

export default Navbar;